"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pocUi = require("@solar/poc-ui");

var _ProductInfo = _interopRequireDefault(require("./ProductInfo"));

var _ProductData = _interopRequireDefault(require("./ProductData"));

var _CertificateList = _interopRequireDefault(require("../Certificate/CertificateList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ProductSheet = function ProductSheet(_ref) {
  var openCertificate = _ref.openCertificate,
      openDataEditor = _ref.openDataEditor,
      product = _ref.product,
      loading = _ref.loading,
      action = _ref.action,
      ProductKeywordProps = _ref.ProductKeywordProps,
      onPublishDataChanges = _ref.onPublishDataChanges,
      labels = _ref.labels;
  var key = product.key,
      title = product.title,
      cover = product.cover,
      certificates = product.certificates;
  var sortedCertificates = certificates ? _toConsumableArray(certificates).sort(function (_ref2, _ref3) {
    var a = _ref2.productionUnit.name;
    var b = _ref3.productionUnit.name;
    return a < b ? -1 : b < a ? 1 : 0;
  }) : [];
  var tabs = {
    info: {
      label: labels.tabs.info,
      component: /*#__PURE__*/_react["default"].createElement(_ProductInfo["default"], {
        product: product,
        ProductKeywordProps: ProductKeywordProps,
        labels: labels.info
      })
    },
    certificates: {
      label: labels.tabs.certificates,
      component: /*#__PURE__*/_react["default"].createElement(_CertificateList["default"], {
        certificates: sortedCertificates,
        openCertificate: openCertificate,
        noMedia: true,
        withKey: true,
        labels: labels
      })
    },
    data: {
      label: labels.tabs.data,
      component: /*#__PURE__*/_react["default"].createElement(_ProductData["default"], {
        product: product,
        labels: labels.data,
        openEditor: openDataEditor,
        onPublishDataChanges: onPublishDataChanges
      })
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_pocUi.CoverTabView, {
    loading: loading,
    title: key,
    header: title,
    cover: cover && cover.src,
    tabs: tabs,
    action: action
  });
};

var _default = ProductSheet;
exports["default"] = _default;